import React from 'react';
import { bool, object } from 'prop-types';
import { connect } from 'react-redux';
import { Radio } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';
import { selectCheckoutPlan } from '../../../../../../../actions/checkoutPlan';
import { isSingleOrderSelected } from '../../../../../../../reducers/checkoutPlan';
import { CHECKOUT_PLANS } from '../../../../../../../utils/checkoutPlan/constants';
import { MP_CHANGED_CHECKOUT_PLAN } from '../../../../../../../utils/mixPanelEvents';
import { PACKAGE_POSITIONS } from '../../../../../../../types/packagePositions';
import { CHECKOUT_PLAN_RADIO } from '../constants';

import './style.scss';

const source = PACKAGE_POSITIONS.TABS;

const SingleOrderPlanRadio = (
    { isSingleOrderSelected = false, selectCheckoutPlan },
    { biEvents }
) => {

    const onChange = () => {
        const selectedCheckoutPlan = CHECKOUT_PLANS.SINGLE_ORDER;

        reportChangeCheckoutPlan(selectedCheckoutPlan);

        selectCheckoutPlan({ selectedCheckoutPlan });
    };

    const reportChangeCheckoutPlan = (selectedCheckoutPlan) => {
        const params = { source, selectedCheckoutPlan };

        biEvents.sendMixPanelEvent({
            eventName: MP_CHANGED_CHECKOUT_PLAN,
            params
        });
    };

    return (
        <Radio className="single-order-plan-radio"
            name={CHECKOUT_PLAN_RADIO}
            checked={isSingleOrderSelected}
            onChange={onChange}
            color={Radio.COLORS.GREEN}>
            <I18n k="gig_page_perseus.recurring.order_once"/>
        </Radio>
    );
};

SingleOrderPlanRadio.propTypes = {
    isSingleOrderSelected: bool
};

SingleOrderPlanRadio.contextTypes = {
    biEvents: object
};

const mapStateToProps = (state) => ({
    isSingleOrderSelected: isSingleOrderSelected(state)
});

const mapDispatchToProps = { selectCheckoutPlan };

export { SingleOrderPlanRadio };
export default connect(mapStateToProps, mapDispatchToProps)(SingleOrderPlanRadio);
